import { render, staticRenderFns } from "./PopupText.vue?vue&type=template&id=d5810c0c&"
import script from "./PopupText.vue?vue&type=script&lang=js&"
export * from "./PopupText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports